<script lang="ts">
  /**
   * The "⋯" sheet: a `Sheet` whose header says what the options are about
   * (`OptionsHeader`) and whose body is `OptionSection`s of `OptionRow`s.
   */
  import type { Snippet } from 'svelte';

  import OptionsHeader from './OptionsHeader.svelte';
  import Sheet from './Sheet.svelte';

  interface Props {
    readonly open: boolean;
    readonly title: string;
    readonly detail?: string | undefined;
    readonly icon?: Snippet | undefined;
    readonly onclose: () => void;
    readonly children: Snippet;
    readonly testid?: string | undefined;
  }
  const { open, title, detail, icon, onclose, children, testid }: Props = $props();

  // The header's title names the sheet: read once, not twice.
  const titleId = $props.id();
</script>

{#snippet header()}
  <OptionsHeader {title} {detail} {icon} {onclose} {titleId} />
{/snippet}

<Sheet {open} {title} {onclose} {header} labelledby={titleId} {testid}>
  {@render children()}
</Sheet>
